import $ from "jquery";
let Helpers;

Helpers = (() => {
	function Helpers() {}

	Helpers.prototype.document = $(document);

	Helpers.prototype.window = $(window);

	Helpers.prototype.body = $("body");

	return Helpers;
})();

export default new Helpers();
